import { Injectable, NgZone } from '@angular/core';
import { PreloadingStrategy, Route } from '@angular/router';
import { Observable } from './util/rxjs';

type Callback = (fn: () => void) => void;

export function requestIdle(zone: NgZone): Callback {
  const win: any = window;
  if (win.requestIdleCallback) {
    return fn => win.requestIdleCallback(fn);
  }
  return fn => zone.runOutsideAngular(() => {
    setTimeout(fn, 10);
  });
}

@Injectable()
export class IdlePreload implements PreloadingStrategy {
  private idleCallback: Callback;

  constructor(ngZone: NgZone) {
    this.idleCallback = requestIdle(ngZone);
  }

  preload(route: Route, fn: () => Observable<any>) {
    this.idleCallback(fn);
    return Observable.of(null);
  }
}

